import { create } from 'zustand';
import { api } from '@/lib/api';

export interface OnboardingTask {
  id: string;
  title: string;
  description?: string;
  category?: string;
  action_path?: string;
  help_text?: string;
  estimated_minutes?: number | null;
  progress?: { completed_at?: string | null; dismissed_at?: string | null } | null;
}

export interface OnboardingPayload {
  template: { id: string; name: string; year: number };
  tasks: OnboardingTask[];
  modal_auto_open_suppressed?: boolean;
}

let fetchPending: Promise<void> | null = null;

interface OnboardingState {
  payload: OnboardingPayload | null;
  loading: boolean;
  fetch: () => Promise<void>;
  setPayload: (payload: OnboardingPayload | null | ((prev: OnboardingPayload | null) => OnboardingPayload | null)) => void;
  reset: () => void;
}

export const useOnboardingStore = create<OnboardingState>((set) => ({
  payload: null,
  loading: false,

  fetch: async () => {
    if (fetchPending) return fetchPending;

    fetchPending = (async () => {
      set({ loading: true });
      try {
        const res = await api.get<{ success: boolean; data?: OnboardingPayload | null }>('/onboarding/current');
        if (res.success && res.data) {
          set({ payload: res.data });
        } else {
          set({ payload: null });
        }
      } finally {
        set({ loading: false });
        fetchPending = null;
      }
    })();

    return fetchPending;
  },

  setPayload: (next) => {
    set((s) => ({
      payload: typeof next === 'function' ? (next as (p: OnboardingPayload | null) => OnboardingPayload | null)(s.payload) : next,
    }));
  },

  reset: () => {
    fetchPending = null;
    set({ payload: null, loading: false });
  },
}));
